module.exports = __webpack_public_path__ + "fonts/Mulish-Bold.d182a4e.ttf";